import type { FC } from "react";
import type { TextProps } from "./Text";
import { Text } from "./Text";

const defaultClasses = `cursor-pointer hover:text-primary-500`;

export const TextLink: FC<TextProps & { onClick?: () => void }> = ({ children, className, onClick, ...props }) => {
  const text = (
    <Text color="text-primary-100" className={`${defaultClasses} ${className ?? ""}`} {...props}>
      {children}
    </Text>
  );

  if (onClick) return <button onClick={onClick}>{text}</button>;
  return text;
};
